import {seasonTypes, chemicalBaseTypes, propertyTypes, countries} from './constants';


// Based on Warden Rules
export const caIdealRanges = (analysis, pool, products, field) => {
  let idealRanges = {};
  let range = [];

  if (!analysis || !analysis.id || !pool || !pool.id || !field) {
    return range;
  }

  if (analysis.season === seasonTypes.closing) {
    switch (pool.chemicalBaseTypeID) {
      case chemicalBaseTypes.brominePool:
      case chemicalBaseTypes.chlorinePool:
      case chemicalBaseTypes.synergyPool:
        idealRanges = {
          saturationIndex: [-0.5, 0.5],
          adjustedTA: [125, 150],
          pH: [7.4, 7.6],
          hardness: ['W', 'C', 'B'].includes(pool.finish) ? [200, 275] : [175, 225],
          totalChlorine: [1, 3],
          freeChlorine: [1, 3],
          totalBromine: [2, 4],
          optimizerPlusBorate: [30, 50],
          TDS: [-Infinity, 2500],
        };
        break;
      case  chemicalBaseTypes.mineralSpringsPool:
      case chemicalBaseTypes.saltWaterPool:
        idealRanges = {
          saturationIndex: [-0.5, 0.5],
          adjustedTA: [125, 150],
          pH: [7.4, 7.6],
          hardness: ['W', 'C', 'B'].includes(pool.finish) ? [200, 275] : [175, 225],
          totalChlorine: [1, 3],
          freeChlorine: [1, 3],
          totalBromine: [2, 4],
          optimizerPlusBorate: [30, 50],
          TDS: [-Infinity, 2500],
        };
        break;
      default:
        break;
    }
  } else {
    let prevAlgicide = products.find(x => x.id === pool.prevAlgicide);
    let pHBuffer = products.find(x => x.id === pool.pHBuffer);

    switch (pool.chemicalBaseTypeID) {
      case chemicalBaseTypes.brominePool:
      case chemicalBaseTypes.chlorinePool:
      case chemicalBaseTypes.synergyPool:
        idealRanges = {
          saturationIndex: [-0.3, 0.3],
          adjustedTA: [125, 150],
          pH: [7.4, 7.6],
          cYA: pool.chemicalBaseTypeID === chemicalBaseTypes.chlorinePool ? [30, 200] : [],
          hardness: ['W', 'C', 'B'].includes(pool.finish) ? [200, 275] : [175, 225],
          totalChlorine: [1, 3],
          freeChlorine: [1, 3],
          totalBromine: [2, 4],
          optimizerPlusBorate: [30, 50],
          quat: prevAlgicide.wardenID === 38 ? [4, 4] : prevAlgicide === 167 ? [6, 6] : [], //N/A
          TDS: [-Infinity, 2500],
        };
        break;
      case  chemicalBaseTypes.mineralSpringsPool:
      case chemicalBaseTypes.saltWaterPool:
        idealRanges = {
          saturationIndex: [-0.3, 0.3],
          adjustedTA: [80, 125],
          pH: [7.4, 7.6],
          cYA: [50, 200],
          hardness: ['W', 'C', 'B'].includes(pool.finish) ? [200, 275] : [175, 225],
          totalChlorine: [1, 3],
          freeChlorine: [1, 3],
          optimizerPlusBorate: [30, 35],
          quat: prevAlgicide.wardenID === 38 ? [4, 4] : prevAlgicide.wardenID === 167 ? [6, 6] : [], //N/A
          minerals: pool.idealSaltPPM,
          salt: pool.idealSaltPPM,
        };
        break;
      case chemicalBaseTypes.bromineSpa:
      case chemicalBaseTypes.chlorineSpa:
      case chemicalBaseTypes.saltWaterSpa:
      case chemicalBaseTypes.synergySpa:
        if (pHBuffer && pHBuffer.wardenID !== 98) {

          let adjustedTAIdealRange = [];

          if (pool.softSoakTRIO) {
            adjustedTAIdealRange = [100, 150];
          } else if (pool.chemicalBaseTypeID !== chemicalBaseTypes.saltWaterSpa) {
            adjustedTAIdealRange = [125, 150];
          } else {
            adjustedTAIdealRange = [80, 150];
          }

          idealRanges = {
            saturationIndex: [-0.5, 0.5],
            adjustedTA: adjustedTAIdealRange,
            pH: [7.2, 7.6],
            hardness: [100, 200],
            totalChlorine: [3, 5],
            freeChlorine: [3, 5],
            totalBromine: [3, 5],
            optimizerPlusBorate: [35, 35],
            initiatorLevel: [25, 99],
            salt: pool.idealSaltPPM,
            TDS: [-Infinity, 2500],
          };
        } else {
          idealRanges = {
            saturationIndex: [-0.5, 0.5],
            totalChlorine: [3, 5],
            freeChlorine: [3, 5],
            totalBromine: [3, 5],
            optimizerPlusBorate: [35, 35],
            initiatorLevel: [25, 99],
            salt: pool.idealSaltPPM,
            TDS: [-Infinity, 2500],
          };
        }
      default:
        break;
    }
  }

  if (idealRanges[field]) {
    range = idealRanges[field];
    if (!Array.isArray(range)) {
      range = [range, range];
    }
  }

  return range;
};

export const usIdealRanges = (analysis, pool, products, field) => {
  let idealRanges = {};
  let range = [];

  if (!analysis || !analysis.id || !pool || !pool.id || !field) {
    return range;
  }

  if (analysis.season === seasonTypes.closing) {
    switch (pool.chemicalBaseTypeID) {
      case chemicalBaseTypes.brominePool:
      case chemicalBaseTypes.chlorinePool:
        idealRanges = {
          saturationIndex: [-0.5, 0.5],
          adjustedTA: [125, 150],
          pH: [7.4, 7.6],
          cYA: [30, 200],
          totalChlorine: [1, 3],
          freeChlorine: [1, 3],
          totalBromine: pool.property === propertyTypes.residential ? [2, 4] : [4, 6],
          optimizerPlusBorate: [30, 50],
          TDS: [-Infinity, 2500],
        };
        break;
      case chemicalBaseTypes.mineralSpringsPool:
      case chemicalBaseTypes.saltWaterPool:
        console.error('Not implemented yet');
        break;
      case chemicalBaseTypes.softswimPool:
        idealRanges = {
          saturationIndex: [-0.5, 0.5],
          adjustedTA: [125, 150],
          hardness: [200, 400],
          sSWB: [30, 50],
          optimizerPlusBorate: [30, 50],
          TDS: [-Infinity, 2500],
        };
        break;
      default:
        break;
    }
  } else {
    let prevAlgicide = products.find(x => x.id === pool.prevAlgicide);
    let pHBuffer = products.find(x => x.id === pool.pHBuffer);
    let sanitizer = products.find(x => x.id === pool.sanitizer);

    switch (pool.chemicalBaseTypeID) {
      case chemicalBaseTypes.brominePool:
      case chemicalBaseTypes.chlorinePool:
        idealRanges = {
          saturationIndex: ['W', 'C', 'B'].includes(pool.finish) ?
            [0, 0.3] : [-0.3, 0.3],
          adjustedTA: [125, 150],
          pH: [7.4, 7.6],
          cYA: [30, 200],
          hardness: ['W', 'C', 'B'].includes(pool.finish) ? [200, 275] : [175, 225],
          totalChlorine: [1, 3],
          freeChlorine: [1, 3],
          totalBromine: pool.property === propertyTypes.residential ? [2, 4] : [4, 6],
          optimizerPlusBorate: [30, 50],
          quat: prevAlgicide.wardenID === 38 ? [2, 2] :
            prevAlgicide.wardenID === 33 ? [4, 6] :
              prevAlgicide.wardenID === 35 ? [2, 2] : [], //N/A
          TDS: [-Infinity, 2500],
        };
        break;
      case  chemicalBaseTypes.mineralSpringsPool:
      case chemicalBaseTypes.saltWaterPool:
        idealRanges = {
          saturationIndex: ['W', 'C', 'B'].includes(pool.finish) ? [0, 0.3] : [-0.3, 0.3],
          minerals: pool.idealSaltPPM,
          salt: pool.idealSaltPPM,
          adjustedTA: [80, 125],
          pH: [7.4, 7.6],
          cYA: [60, 200],
          hardness: ['W', 'C', 'B'].includes(pool.finish) ? [200, 275] : [175, 225],
          totalChlorine: [1, 3],
          freeChlorine: [1, 3],
          optimizerPlusBorate: [30, 35],
          quat: prevAlgicide.wardenID === 38 ? [2, 2] :
            prevAlgicide.wardenID === 33 ? [4, 6] :
              prevAlgicide.wardenID === 35 ? [2, 2] : [], //N/A
        };
        break;
      case chemicalBaseTypes.bromineSpa:
      case chemicalBaseTypes.chlorineSpa:
      case chemicalBaseTypes.saltWaterSpa:
        if (pHBuffer && pHBuffer.wardenID !== 98) {
          let adjustedTAIdealRange = [120, 150];

          if (pool.softSoakTRIO && pool.chemicalBaseTypeID !== chemicalBaseTypes.saltWaterSpa && !pool.usingVanishingAct) {
            adjustedTAIdealRange = [100, 120];
          } else if (pool.chemicalBaseTypeID === chemicalBaseTypes.saltWaterSpa) {
            adjustedTAIdealRange = [80, 115];
          } else if (!pool.usingVanishingAct) {
            adjustedTAIdealRange = [120, 150];
          }

          idealRanges = {
            saturationIndex: [-0.5, 0.5],
            adjustedTA: adjustedTAIdealRange,
            pH: [7.4, 7.6],
            hardness: pool.usingVanishingAct ? [25, 75] : pool.softSoakTRIO ? [150, 200] : [100, 200],
            totalChlorine: [3, 5],
            freeChlorine: [3, 5],
            totalBromine: sanitizer.wardenID === 42 ? [3, 5] : pool.property === propertyTypes.residential ? [2, 4] : [4, 6],
            optimizerPlusBorate: [30, 50],
            salt: pool.idealSaltPPM,
            TDS: [-Infinity, 2500],
          };

        } else {
          console.error('Not implemented yet');
        }
      case chemicalBaseTypes.softswimPool:
        idealRanges = {
          adjustedTA: [80, 120],
          pH: [7.2, 7.6],
          hardness: pool.usingVanishingAct ? [50, 150] : [200, 300],
          sSKShockResidual: [5, 12],
          sSKSanitizerResidual: [30, 50],
          TDS: [-Infinity, 2500],
        };
        break;
      default:
        break;
    }
  }

  if (idealRanges[field]) {
    range = idealRanges[field];
    if (!Array.isArray(range)) {
      range = [range, range];
    }
  }

  return range;
};


export const getIdealRange = (analysis, pool, products, field, country) => {
  if (country === countries.CA) {
    return caIdealRanges(analysis, pool, products, field);
  }
  return usIdealRanges(analysis, pool, products, field);
};


